/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { TeamDevelopmentStatisticsResponseDto } from '../models';
/**
 * TeamDevelopmentStatisticsApi - axios parameter creator
 * @export
 */
export const TeamDevelopmentStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Feeds the four KPI tiles of the \"Filtry i statystyki zespołu\" bar in the \"Przegląd zespołu\" (Twój Zespół) view. Scope: direct subordinates of the logged-in user (by accessType), computed against each employee\'s active development-path cycle. 
         * @summary Team development statistics for the logged-in supervisor
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDevelopmentStatistics: async (accessType?: EmployeeAccessTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/team/development/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamDevelopmentStatisticsApi - functional programming interface
 * @export
 */
export const TeamDevelopmentStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamDevelopmentStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Feeds the four KPI tiles of the \"Filtry i statystyki zespołu\" bar in the \"Przegląd zespołu\" (Twój Zespół) view. Scope: direct subordinates of the logged-in user (by accessType), computed against each employee\'s active development-path cycle. 
         * @summary Team development statistics for the logged-in supervisor
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamDevelopmentStatistics(accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDevelopmentStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamDevelopmentStatistics(accessType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamDevelopmentStatisticsApi.getTeamDevelopmentStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamDevelopmentStatisticsApi - factory interface
 * @export
 */
export const TeamDevelopmentStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamDevelopmentStatisticsApiFp(configuration)
    return {
        /**
         * Feeds the four KPI tiles of the \"Filtry i statystyki zespołu\" bar in the \"Przegląd zespołu\" (Twój Zespół) view. Scope: direct subordinates of the logged-in user (by accessType), computed against each employee\'s active development-path cycle. 
         * @summary Team development statistics for the logged-in supervisor
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDevelopmentStatistics(accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamDevelopmentStatisticsResponseDto> {
            return localVarFp.getTeamDevelopmentStatistics(accessType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamDevelopmentStatisticsApi - interface
 * @export
 * @interface TeamDevelopmentStatisticsApi
 */
export interface TeamDevelopmentStatisticsApiInterface {
    /**
     * Feeds the four KPI tiles of the \"Filtry i statystyki zespołu\" bar in the \"Przegląd zespołu\" (Twój Zespół) view. Scope: direct subordinates of the logged-in user (by accessType), computed against each employee\'s active development-path cycle. 
     * @summary Team development statistics for the logged-in supervisor
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentStatisticsApiInterface
     */
    getTeamDevelopmentStatistics(accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<TeamDevelopmentStatisticsResponseDto>;

}

/**
 * TeamDevelopmentStatisticsApi - object-oriented interface
 * @export
 * @class TeamDevelopmentStatisticsApi
 * @extends {BaseAPI}
 */
export class TeamDevelopmentStatisticsApi extends BaseAPI implements TeamDevelopmentStatisticsApiInterface {
    /**
     * Feeds the four KPI tiles of the \"Filtry i statystyki zespołu\" bar in the \"Przegląd zespołu\" (Twój Zespół) view. Scope: direct subordinates of the logged-in user (by accessType), computed against each employee\'s active development-path cycle. 
     * @summary Team development statistics for the logged-in supervisor
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamDevelopmentStatisticsApi
     */
    public getTeamDevelopmentStatistics(accessType?: EmployeeAccessTypeDto, options?: RawAxiosRequestConfig) {
        return TeamDevelopmentStatisticsApiFp(this.configuration).getTeamDevelopmentStatistics(accessType, options).then((request) => request(this.axios, this.basePath));
    }
}

